import React, { useEffect } from 'react';
import { notification, Row } from 'antd';
import { Formik, Form as FormikForm } from 'formik';
import Logo from 'assets/logo/logo_full.png';
import InputField from 'shared/components/InputField';
import COButton from 'shared/components/COButton';
import styles from './SetNewPasswordForm.module.scss';
import AuthenticationService from 'services/AuthenticationService/authentication.service';
import { Fields, validationSchema } from './SetNewPasswordFormConstants';
import { SetNewPasswordFormEnums } from 'enums/SetNewPasswordFormEnums';

interface SetNewPasswordProps {
  email: string;
}

interface SetNewPasswordFormValues {
  email: string;
  createPassword: string;
}

const SetNewPasswordForm: React.FC<SetNewPasswordProps> = ({
  email,
}: SetNewPasswordProps) => {
  const { setNewPassword, buttonLoading, setNewPasswordSuccess } =
    AuthenticationService();
  const initialValues = {
    email: email ? email : '',
    createPassword: '',
    confirmpassword: '',
  };
  const handleApiSubmission = (values: SetNewPasswordFormValues) => {
    const ValueObj = {
      email: values.email,
      password: values.createPassword,
    };

    setNewPassword(ValueObj);
  };
  useEffect(() => {
    if (setNewPasswordSuccess) {
      notification.success({
        message: setNewPasswordSuccess,
      });
    }
  }, [setNewPasswordSuccess]);
  return (
    <div className={styles.formContainer}>
      <Row className={styles.logoContainer}>
        <img
          src={Logo}
          alt={SetNewPasswordFormEnums.IMAGE_ALT}
          className={styles.logo}
        />
      </Row>
      <Row className={styles.headingContainer}>
        <div>
          <h1>{SetNewPasswordFormEnums.HEADING}</h1>
        </div>
        <div>
          <h2>{SetNewPasswordFormEnums.SUBHEADING}</h2>
        </div>
      </Row>
      <div className={styles.fieldsContainer}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={values => handleApiSubmission(values)}>
          {formik => (
            <FormikForm>
              {Fields.map((field, index) => {
                return (
                  <div key={index} className={styles.fieldContainer}>
                    <InputField
                      disabled={field.disabled}
                      name={field.name}
                      password={field.password}
                      placeholderstring={field.placeholder}
                      label={field.label}
                    />
                  </div>
                );
              })}

              <div className={styles.buttonContainer}>
                <COButton
                  submit
                  loading={buttonLoading}
                  disabled={!formik.isValid}>
                  {SetNewPasswordFormEnums.BUTTON_LABEL_SUBMIT}
                </COButton>
              </div>
            </FormikForm>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default SetNewPasswordForm;
